import { adminUrl, bbdBursarUrl } from "../../../../theme/theme"
import { AdminColours, BBDColours, UkukhulaColours } from "../../enums/categories"

export function getColourTheme() {
  if (bbdBursarUrl(window.location.href)) {
    return BBDColours
  } else if (adminUrl(window.location.href)) {
    return AdminColours
  } else {
    return UkukhulaColours
  }
}